import React from "react";

import "./Input.css";

const input = props => {
  let inputElement = null;
  const inputClasses = [props.inputClasses];

  if (props.invalid && props.shouldValidate && props.touched) {
    inputClasses.push("is-invalid");
  }

  switch (props.elementType) {
    case "input":
      inputElement = (
        <input
          className={inputClasses.join(" ")}
          {...props.elementConfig}
          value={props.value}
          onChange={props.changed}
        />
      );
      break;
    case "textarea":
      inputElement = (
        <textarea
          className={inputClasses.join(" ")}
          {...props.elementConfig}
          value={props.value}
          onChange={props.changed}
        />
      );
      break;
    default:
      inputElement = (
        <input
          className={inputClasses.join(" ")}
          {...props.elementConfig}
          value={props.value}
          onChange={props.changed}
        />
      );
  }

  return (
    <div className="form-group">
      <div className="input-group">
        <span className="input-group-addon d-flex align-items-center justify-content-center">
          <i className={props.icon} />
        </span>
        {inputElement}
      </div>
    </div>
  );
};

export default input;



// WEBPACK FOOTER //
// ./src/components/UI/Input/Input.js